import type { NAuth } from '@app/types';

export enum ErrorReportsEndpoints {
  Send = 'Send',
}

export interface SendErrorReportRequest {
  UserName: string;
  UserPhone: string;
  Browser: string;
  Message: string;
  ActiveBranchId: NAuth.UserPrint['activeBranchId'];
  data: FormData | null;
}

export type SendErrorReportResponse = void;
